var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneheart1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.7322 39.5551C60.9571 38.7768 60.0313 38.1647 59.0114 37.7564C57.9916 37.3481 56.8992 37.1521 55.8011 37.1804C54.7029 37.2087 53.6221 37.4608 52.6247 37.9211C51.6272 38.3814 50.7342 39.0404 50.0002 39.8577C49.2737 39.0555 48.394 38.4069 47.4129 37.95C46.4319 37.4932 45.3692 37.2374 44.2877 37.1977C43.2062 37.158 42.1277 37.3353 41.1158 37.719C40.1038 38.1028 39.179 38.6852 38.3957 39.432C37.6124 40.1788 36.9866 41.0749 36.5551 42.0674C36.1236 43.0599 35.8952 44.1287 35.8833 45.2109C35.8714 46.2931 36.0763 47.3667 36.4859 48.3684C36.8955 49.3702 37.5015 50.2797 38.2681 51.0436L50.0002 62.8205L61.7322 51.0423C63.2504 49.5163 64.1027 47.4513 64.1027 45.2987C64.1027 43.1461 63.2504 41.0811 61.7322 39.5551Z",
    stroke: "#171A1F",
    strokeWidth: 3.07692,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3594 78.2051L75.6414 78.2051",
    stroke: "#171A1F",
    strokeWidth: 3.07692,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3594 21.7949L75.6414 21.7949",
    stroke: "#171A1F",
    strokeWidth: 3.07692,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6414 83.3334C75.637 84.6922 75.0953 85.994 74.1346 86.9548C73.1738 87.9156 71.872 88.4573 70.5132 88.4617L29.4876 88.4617C28.1288 88.4573 26.827 87.9156 25.8662 86.9548C24.9055 85.994 24.3638 84.6922 24.3594 83.3334L24.3594 16.6668C24.3638 15.308 24.9055 14.0062 25.8662 13.0454C26.827 12.0847 28.1288 11.543 29.4876 11.5386L70.5132 11.5386C71.872 11.543 73.1738 12.0847 74.1346 13.0454C75.0953 14.0062 75.637 15.308 75.6414 16.6668L75.6414 83.3334Z",
    stroke: "#171A1F",
    strokeWidth: 3.07692,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneheart1);
export default __webpack_public_path__ + "static/media/Phone heart 1.a974c6e3d378c97b98244705723a1356.svg";
export { ForwardRef as ReactComponent };